export default {
	lang: 'it',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'Sécurité du compte',
		"nav1": 'Mon disque cloud',
		"nav2": 'Déconnexion',
		"nav3": 'Connexion/Inscription',
		"nav4": `Peut enregistrer les appels et le contenu audio du téléphone et les convertir en texte. Nécessite la connexion d'écouteurs de la série VTransBUDS.`,
		"nav5": 'Scannez le code pour télécharger',
		"nav6": 'Communication importante, retour en arrière efficace',
		"speaker_not_null": 'Impossible de modifier le haut-parleur vide !',
		"speaker": 'Haut-parleur',
		"copy_success": 'Copie réussie',
	},
	login: {
		"login1": 'Connexion par mot de passe',
		"login2": 'Connexion par SMS',
		"loginTab3": 'Connexion par e-mail',
		"login3": 'E-mail',
		"login4": 'Mot de passe de connexion',
		"login5": 'Numéro de téléphone portable',
		"login6": 'Veuillez sélectionner',
		"login7": 'Code de vérification du téléphone portable',
		"login8": 'Connexion',
		"login9": 'Mot de passe oublié',
		"login10": `S'inscrire`,
		"login11": 'En vous connectant, vous acceptez',
		"login12": 'Contrat de service',
		"login13": 'Contrat de confidentialité',
		"login14": 'Obtenir',
		"login15": 'Chine',
		"login16": 'Veuillez saisir votre compte',
		"login17": 'Veuillez saisir votre mot de passe',
		"login18": 'Connexion réussie !',
		"login19": 'Veuillez saisir le code de vérification !',
		"login20": 'Envoyé avec succès !',
		"login21": 'Et',
		"login22": `Disque cloud de l'enregistreur`,
		"login23": 'Mes écritures',
		"login24": 'Ma conversation',
		"login25": 'Sécurité du compte',
		"login26": 'Déconnexion',
		"login27": `Récupération du mot de passe de l'e-mail`,
		"login28": 'E-mail',
		"login29": `Code de vérification de l'e-mail`,
		"login30": 'Définir un mot de passe de connexion (6 à 16 caractères)',
		"login31": 'Saisir à nouveau le mot de passe de connexion',
		"login32": 'Envoyer',
		"login33": 'Retourner à login',
		"login34": 'Modification réussie !',
	},
	register: {
		"register1": 'Numéro de téléphone portable',
		"register2": 'Veuillez saisir votre numéro de téléphone portable',
		"register3": 'Veuillez sélectionner',
		"register4": 'Code de vérification du téléphone portable',
		"register5": 'Définir un mot de passe',
		"register6": 'Veuillez saisir le code de vérification',
		"register7": '6 à 16 caractères',
		"register8": 'Confirmation du mot de passe',
		"register9": 'E-mail',
		"register10": `Veuillez saisir l'e-mail`,
		"register11": `Code de vérification de l'e-mail`,
		"register12": 'Veuillez saisir le code de vérification',
		"register13": `J'ai lu et j'accepte`,
		"register14": 'Veuillez lire et vérifier les conditions',
		"register15": 'Le format du numéro de téléphone portable est incorrect / Le numéro de téléphone portable a été enregistré',
		"register16": 'Le code de vérification du téléphone portable est Erreur',
		"register17": `Veuillez saisir votre adresse e-mail / Erreur de format d'e-mail`,
		"register18": `Erreur de format d'e-mail`,
		"register19": `Erreur de code de vérification d'e-mail`,
		"register20": 'Veuillez définir un mot de passe de 6 à 16 caractères',
		"register21": 'Erreur de format de mot de passe',
		"register22": 'Les deux mots de passe sont incompatibles, veuillez les saisir à nouveau',
		"register23": 'Veuillez saisir le mot de passe',
		"register24": 'Inscription réussie !',
		"register25": 'Erreur de code de vérification',
	},
	recorder: {
		"recorder1": 'Mon disque cloud',
		"recorder2": `Capacité de l'espace cloud`,
		"recorder3": 'Fichiers récents',
		"recorder331": 'Corbeille',
		"recorder332": 'Tout supprimer',
		"recorder4": 'Nom',
		"recorder5": 'Durée audio',
		"recorder6": 'Taille du fichier',
		"recorder7": 'Heure de création',
		"recorder8": 'Opération',
		"recorder9": `Description de l'espace cloud`,
		"recorder10": 'Audio',
		"recorder11": 'Fichier OCR',
		"recorder12": `1. À quoi sert l'espace cloud ?`,
		"recorder13": `Après l'enregistrement sur l'enregistreur, vous pouvez télécharger les fichiers audio et transcrits sur l'espace cloud. Même sans l'enregistreur, vous pouvez accéder à l'espace cloud pour visionner l'audio.`,
		"recorder14": `2. Comment télécharger vers l'espace cloud ?`,
		"recorder15": `Accédez à [Mes fichiers] sur l'enregistreur, sélectionnez le fichier cible et appuyez longuement pour afficher l'option, puis cliquez sur « Télécharger » pour télécharger le fichier vers l'espace cloud.`,
		"recorder16": `3. Comment afficher/gérer les fichiers de l'espace cloud ?`,
		"recorder17": `Connectez-vous au site web officiel de Beibo, sélectionnez « My-Recorder Cloud Disk » pour visualiser les fichiers de l'enregistreur téléchargés. Vous pouvez sélectionner le fichier cible à télécharger, supprimer et effectuer d'autres opérations. Vous pouvez nettoyer le stockage cloud en supprimant les fichiers cloud !`,
		"recorder18": 'Non transcrit',
		"recorder19": 'Voir le résumé',
		"recorder20": 'Orateur',
		"recorder21": `Modifier le nom de l'orateur`,
		"recorder22": 'Confirmer',
		"recorder23": 'Télécharger',
		"recorder24": 'Télécharger le contenu :',
		"recorder25": 'Paramètres de téléchargement :',
		"recorder26": `Afficher l'orateur`,
		"recorder27": 'Annuler',
		"recorder28": 'Partage du lien',
		"recorder29": 'Toute personne recevant le lien peut y accéder. Lecture uniquement possible. Le lien est valable 7 jours.',
		"recorder30": 'Copier le lien',
		"recorder31": 'Numériser et visualiser rapidement',
		"recorder32": 'Organisation intelligente',
		"recorder33": 'Distinguer les locuteurs',
		"recorder34": 'Distinguer intelligemment les textes transcrits selon le rôle des locuteurs',
		"recorder35": 'Régularisation intelligente de la langue parlée',
		"recorder36": 'Filtrer automatiquement les particules modales, les mots répétés et les mots de pause',
		"recorder37": 'Filtrage des voix non humaines',
		"recorder38": `Sauter automatiquement l'audio sans voix humaine ni bruit pendant la lecture`,
		"recorder39": 'Veuillez sélectionner',
		"recorder40": 'Document',
		"recorder41": 'Audio',
		"recorder42": 'Document+Audio',
		"recorder43":'Invite',
		"recorder44":'Cette opération supprimera le fichier. Voulez-vous continuer ?',
		"recorder441":'Cette opération supprimera tous les fichiers. Voulez-vous continuer ?',
		"recorder45":'OK',
		"recorder46":'Annuler',
		"recorder47":'Suppression réussie !',
		"recorder48":'Suppression annulée',
		"recorder49":'Aucune marque pour le moment',
		"recorder50":'Enregistrement…',
		"recorder51":'Corbeille',
	},
	personal: {
		"personal1": 'Paramètres du compte',
		"personal2": 'Informations personnelles',
		"personal3": 'Avatar',
		"personal4": 'Télécharger un fichier',
		"personal5": `Prise en charge des formats JPG, JPEG, GIF et PNG, prise en charge des images jusqu'à 2 Mo`,
		"personal6": 'Pseudonyme',
		"personal7": 'Veuillez saisir votre pseudo',
		"personal8": 'Sexe',
		"personal9": 'M.',
		"personal10": 'Mme.',
		"personal11": 'Confidentiel',
		"personal12": 'Date de naissance',
		"personal13": 'Veuillez sélectionner votre date de naissance',
		"personal14": 'Profession',
		"personal15": 'Veuillez sélectionner votre profession',
		"personal16": 'Veuillez saisir votre profession (facultatif)',
		"personal17": 'Pays',
		"personal18": 'Veuillez sélectionner votre Pays',
		"personal19": 'Enregistrer',
		"personal20": 'Informations personnelles',
		"personal21": 'Sécurité du compte',
		"personal22": 'Photos prises en charge uniquement dans les 2 M',
		"personal23": 'Téléchargement réussi !',
		"personal24": 'Modification réussie !',
		"personal25": 'Sécurité du compte',
		"personal26": 'Mot de passe de connexion',
		"personal27": 'Modifier',
		"personal28": 'E-mail',
		"personal29": 'Modifier',
		"personal30": 'Annulation du compte',
		"personal32": 'Êtes-vous sûr de vouloir annuler votre compte ?',
		"personal33": `Après l'annulation, tout le contenu de votre compte sera supprimé. Veuillez agir avec prudence. `,
		"personal34": 'Annuler',
		"personal35": 'Confirmer',
		"personal36": 'Authentification',
		"personal37": `Pour confirmer que vous êtes bien le/la titulaire de l'autorisation, veuillez compléter la vérification d'identité à l'aide du code de vérification fourni par e-mail.`,
		"personal38": 'E-mail',
		"personal39": 'Code de vérification',
		"personal40": 'Veuillez saisir le code de vérification',
		"personal41": 'Suivant',
		"personal42": 'Définir une nouvelle adresse e-mail',
		"personal43": 'E-mail',
		"personal44": 'Veuillez saisir une nouvelle adresse e-mail',
		"personal45": 'Code de vérification',
		"personal46": 'Veuillez saisir le code de vérification',
		"personal47": 'Confirmer',
		"personal48": 'Définir un nouveau mot de passe de connexion',
		"personal49": 'Nouveau mot de passe de connexion',
		"personal50": 'Veuillez saisir un nouveau mot de passe',
		"personal51": 'Confirmer le nouveau mot de passe',
		"personal52": 'Veuillez saisir à nouveau le nouveau mot de passe',
		"personal53": 'Confirmer',
		"personal54": 'Obtenir',
		"personal55": `Erreur de format d'e-mail`,
		"personal56": 'Modification réussie !',
		"personal57": 'Veuillez définir un mot de passe de 6 à 16 caractères',
		"personal58": 'Les deux mots de passe saisis sont incompatibles',
		"personal59": 'Modification réussie !',
		"personal60": 'Déconnexion réussie !',
		"share_url": "Condivisione link",
		"share_url_7_day": "Il link di condivisione è valido per 7 giorni. Prima della scadenza, chiunque riceva il link può accedervi.",
		"share_audio": "Registrazione audio",
		"share_trans_text": "Trascrizione",
		"share_summny_text": "Riepilogo",
		"share_map": "Mappa mentale",
		"share_url_pw": "Crittografia di accesso",
		"share_random_pw": "Password generata casualmente",
		"share_url_copy": "Copia link",
		"share_link_pw": "Password di accesso",
		"share_copy_success": "Copia eseguita correttamente!",
		"share_speaker": "Altoparlante",
		"share_no_update_speaker": "Impossibile modificare. L'altoparlante è vuoto",
		"share_no_trans":"No trascrizione",
		"share_no_summny":"Nessun riepilogo",
		"share_no_map":"Nessun contenuto sulla mappa",
		"share_trans_text_1": "Trascrizione",
		"share_summny_text_1": "Riepilogo",
		"share_map_1": "Mappa",
		"share_save": "Salvataggio eseguito correttamente",
		"share_no_map":"Immagine della mappa non generata",
		"share_update_text": "Modifica il testo della trascrizione",
		"share_update_text2": "Modifica il testo riassuntivo",
		"showLoading": "caricamento...",
	}
}